import { Component, OnInit } from '@angular/core';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'pps-access-setting-action',
  template: `
    <select [(ngModel)]="accessPermission" (change)="onChange($event.target.value)">
      <option value="0">No Access</option>
      <option value="1">View Only Access</option>
      <option value="2">Full Access</option>
    </select>
  `,
  styles: [
  ],
})
export class AccessSettingActionComponent implements AgRendererComponent {
  private params: any;
  accessPermission: string;

  constructor() { }

  refresh(params: any): boolean {
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.accessPermission = this.params.data.accessPermission + "";
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  onChange(newValue){
    console.log("New value " + newValue);
    console.log(this.params.data);
    this.params.data.accessPermission = newValue * 1;
    this.params.context.componentParent.updateRoleProjectColumnAccessSetting(this.params.data);
    this.params.context.componentParent.projectColumnGridApi.redrawRows({rowNodes: [this.params.node]});
  }
}
